// Infraestrutura e comodidades do condomínio (cadastro + exibição pública)


export const CONDO_DETAILS_DEFAULTS = {
  // Segurança / acesso
  gatedCommunity: false,
  security24h: false,
  walledArea: false,
  remoteDoorman: false,
  facialRecognition: false,
  biometrics: false,
  securityCameras: false,
  electricFence: false,
  accessControl: false,
  armedVigilance: false,
  pedestrianClausure: false,
  vehicleClausure: false,
  intercom: false,
  guardHouse: false,
  serviceEntrance: false,
  remoteMonitoring: false,
  electronicGate: false, // �SAcesso por tag⬝

  // Regras e permissões
  petsAllowed: false,
  airbnbAllowed: false,
  seasonalRentalAllowed: false,
  commercialUseAllowed: false,
  reformsAllowed: false,
  familyCondo: false,
  noiseRestriction: false,

  // Lazer / comodidades
  gym: false, // Área fitness externa
  pool: false,
  heatedPool: false,
  indoorPool: false,
  wetDeck: false,
  jacuzzi: false,
  spa: false,
  playground: false,
  kidsPlayroom: false,
  gamesRoom: false,
  cinema: false,
  coworking: false,
  gourmetKitchen: false, // Espaço gourmet
  barbecueArea: false,
  kioskArea: false,
  rooftopArea: false,
  loungeArea: false,
  fireplaceArea: false,
  meetingRoom: false,
  womenSpace: false,
  teenSpace: false,
  petZone: false,
  petCare: false,
  miniMarket: false,
  communityGarden: false,

  // Mantidos do schema atual
  kidPool: false,
  partyRoom: false,
  hotSauna: false,
  coldSauna: false,

  // Esportes
  multiSportsCourt: false,
  tennisCourt: false,
  beachTennisCourt: false,
  soccerField: false,
  walkingTrack: false,
  runningTrack: false,
  bikeParking: false,
  skatePark: false,
  crossfitOutdoor: false,

  // Infraestrutura
  elevator: false,
  serviceElevator: false,
  generator: false,
  solarEnergy: false,
  rainwaterHarvesting: false,
  artesianWell: false,
  centralGas: false,
  gasHeating: false,
  solarHeating: false,
  fiberOptic: false,
  includedInternet: false,
  visitorParking: false,
  evCharger: false,
  internalMarket: false,
  communityLaundry: false,
  privateStorage: false,
  decoratedHall: false,

  // Acessibilidade
  pcdAccessibility: false,
  rampsAccess: false,
  tactileFloor: false,
  adaptedElevator: false,
  accessibleBathroom: false,

  // Diferenciais premium
  seaView: false,
  lakeView: false,
  mountainView: false,
  beachfront: false,
  onSand: false,
  condoClub: false,
  highStandard: false,
  homeAutomationPreparation: false,
  commonAreasAutomation: false,
  cleaningService: false,
  laundryService: false,
  deliveryRoom: false,
  marketplaceInternal: false,
  doorman: false // Concierge
};

export const CONDO_DETAILS_TOPICS = [
  {
    title: 'Segurança',
    items: [
      { key: 'gatedCommunity', label: 'Condomínio fechado' },
      { key: 'security24h', label: 'Segurança 24h' },
      { key: 'walledArea', label: 'Área murada' },
      { key: 'remoteDoorman', label: 'Portaria remota' },
      { key: 'facialRecognition', label: 'Reconhecimento facial' },
      { key: 'biometrics', label: 'Biometria' },
      { key: 'securityCameras', label: 'Câmeras de segurança' },
      { key: 'electricFence', label: 'Cerca elétrica' },
      { key: 'accessControl', label: 'Controle de acesso' },
      { key: 'armedVigilance', label: 'Vigilância armada' },
      { key: 'pedestrianClausure', label: 'Clausura para pedestres' },
      { key: 'vehicleClausure', label: 'Clausura para veículos' },
      { key: 'intercom', label: 'Interfone' },
      { key: 'guardHouse', label: 'Guarita' },
      { key: 'serviceEntrance', label: 'Entrada de serviço' },
      { key: 'electronicGate', label: 'Acesso por tag' },
      { key: 'remoteMonitoring', label: 'Monitoramento remoto' }
    ]
  },
  {
    title: 'Lazer',
    items: [
      { key: 'pool', label: 'Piscina' },
      { key: 'heatedPool', label: 'Piscina aquecida' },
      { key: 'indoorPool', label: 'Piscina coberta' },
      { key: 'wetDeck', label: 'Deck molhado' },
      { key: 'jacuzzi', label: 'Hidromassagem' },
      { key: 'spa', label: 'Spa' },
      { key: 'hotSauna', label: 'Sauna quente' },
      { key: 'coldSauna', label: 'Sauna fria' },
      { key: 'playground', label: 'Playground' },
      { key: 'kidsPlayroom', label: 'Brinquedoteca' },
      { key: 'gamesRoom', label: 'Sala de jogos' },
      { key: 'cinema', label: 'Cinema' },
      { key: 'coworking', label: 'Coworking' },
      { key: 'gourmetKitchen', label: 'Espaço gourmet' },
      { key: 'barbecueArea', label: 'Churrasqueira' },
      { key: 'kioskArea', label: 'Quiosque' },
      { key: 'rooftopArea', label: 'Rooftop' },
      { key: 'loungeArea', label: 'Lounge' },
      { key: 'fireplaceArea', label: 'Fireplace' },
      { key: 'meetingRoom', label: 'Sala de reunião' },
      { key: 'womenSpace', label: 'Espaço mulher' },
      { key: 'teenSpace', label: 'Espaço teen' },
      { key: 'petZone', label: 'Espaço pet' },
      { key: 'petCare', label: 'Pet care' },
      { key: 'miniMarket', label: 'Mini mercado' },
      { key: 'communityGarden', label: 'Horta comunitária' },
      { key: 'kidPool', label: 'Piscina Infantil' },
      { key: 'partyRoom', label: 'Salão de festas' }
    ]
  },
  {
    title: 'Esportes',
    items: [
      { key: 'gym', label: 'Área fitness externa' },
      { key: 'multiSportsCourt', label: 'Quadra poliesportiva' },
      { key: 'tennisCourt', label: 'Quadra de tênis' },
      { key: 'beachTennisCourt', label: 'Quadra de beach tennis' },
      { key: 'soccerField', label: 'Campo de futebol' },
      { key: 'walkingTrack', label: 'Pista de caminhada' },
      { key: 'runningTrack', label: 'Pista de corrida' },
      { key: 'bikeParking', label: 'Bicicletário' },
      { key: 'skatePark', label: 'Skate park' },
      { key: 'crossfitOutdoor', label: 'Crossfit outdoor' }
    ]
  },
  {
    title: 'Infraestrutura',
    items: [
      { key: 'elevator', label: 'Elevador' },
      { key: 'serviceElevator', label: 'Elevador de serviço' },
      { key: 'generator', label: 'Gerador' },
      { key: 'solarEnergy', label: 'Energia solar' },
      { key: 'rainwaterHarvesting', label: 'Captação de água da chuva' },
      { key: 'artesianWell', label: 'Poço artesiano' },
      { key: 'centralGas', label: 'Gás central' },
      { key: 'gasHeating', label: 'Aquecimento a gás' },
      { key: 'solarHeating', label: 'Aquecimento solar' },
      { key: 'fiberOptic', label: 'Fibra óptica' },
      { key: 'includedInternet', label: 'Internet inclusa' },
      { key: 'visitorParking', label: 'Vagas para visitantes' },
      { key: 'evCharger', label: 'Carregador para veículo elétrico' },
      { key: 'internalMarket', label: 'Mercado interno' },
      { key: 'communityLaundry', label: 'Lavanderia coletiva' },
      { key: 'privateStorage', label: 'Depósito privativo' },
      { key: 'decoratedHall', label: 'Hall decorado' }
    ]
  },
  {
    title: 'Acessibilidade',
    items: [
      { key: 'pcdAccessibility', label: 'Acessibilidade PCD' },
      { key: 'rampsAccess', label: 'Rampas de acesso' },
      { key: 'tactileFloor', label: 'Piso tátil' },
      { key: 'adaptedElevator', label: 'Elevador adaptado' },
      { key: 'accessibleBathroom', label: 'Banheiro acessível' }
    ]
  },
  {
    title: 'Regras e permissões',
    items: [
      { key: 'petsAllowed', label: 'Aceita pets' },
      { key: 'airbnbAllowed', label: 'Airbnb permitido' },
      { key: 'seasonalRentalAllowed', label: 'Locação por temporada' },
      { key: 'commercialUseAllowed', label: 'Permitido uso comercial' },
      { key: 'reformsAllowed', label: 'Permitido reformas' },
      { key: 'familyCondo', label: 'Condomínio familiar' },
      { key: 'noiseRestriction', label: 'Restrição de barulho' }
    ]
  },
  {
    title: 'Diferenciais premium',
    items: [
      { key: 'seaView', label: 'Vista para o mar' },
      { key: 'lakeView', label: 'Vista para lago' },
      { key: 'mountainView', label: 'Vista para montanha' },
      { key: 'beachfront', label: 'Frente mar' },
      { key: 'onSand', label: 'Pé na areia' },
      { key: 'condoClub', label: 'Condomínio clube' },
      { key: 'highStandard', label: 'Alto padrão' },
      { key: 'homeAutomationPreparation', label: 'Preparação para automação residencial' },
      { key: 'commonAreasAutomation', label: 'Automação das áreas comuns' },
      { key: 'doorman', label: 'Concierge' },
      { key: 'cleaningService', label: 'Serviço de limpeza' },
      { key: 'laundryService', label: 'Serviço de lavanderia' },
      { key: 'deliveryRoom', label: 'Delivery room' },
      { key: 'marketplaceInternal', label: 'Marketplace interno' }
    ]
  }
];

/** Itens ativos de condoDetails, na ordem do cadastro, com r�tulo garantido. */
/** Tópico fixo para comodidades que não se encaixam nas categorias padrão. */
export const CONDO_DETAILS_OTHER_TOPIC = 'Outros';

/** Títulos de tópicos disponíveis ao criar opção personalizada (inclui Outros). */
export const CONDO_DETAILS_TOPIC_TITLES = [
  ...CONDO_DETAILS_TOPICS.map((t) => t.title),
  CONDO_DETAILS_OTHER_TOPIC
];

export function getCondoCustomItemKey(id) {
  return `custom_${id}`;
}

export function createCondoCustomItemId() {
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
}

/** Normaliza a lista de opções personalizadas salvas no documento. */
export function normalizeCondoDetailsCustom(items) {
  if (!Array.isArray(items)) return [];
  return items
    .filter((item) => item && typeof item.id === 'string' && item.id.length > 0)
    .map((item) => ({
      id: item.id,
      topic: typeof item.topic === 'string' && item.topic.trim() ? item.topic.trim() : CONDO_DETAILS_OTHER_TOPIC,
      label: typeof item.label === 'string' ? item.label.trim() : ''
    }))
    .filter((item) => item.label.length > 0);
}

export function getCustomCondoItemsByTopic(customItems, topicTitle) {
  return normalizeCondoDetailsCustom(customItems).filter((item) => item.topic === topicTitle);
}

/**
 * @param {object} condoDetails
 * @param {Array} customCatalog — catálogo global e/ou legado do documento
 */
export function getActiveCondoDetailItems(condoDetails = {}, customCatalog = []) {
  if (!condoDetails || typeof condoDetails !== 'object') return [];
  const standard = CONDO_DETAILS_TOPICS.flatMap((topic) =>
    topic.items.filter((item) => condoDetails[item.key] === true)
  );
  const custom = normalizeCondoDetailsCustom(customCatalog)
    .filter((item) => condoDetails[getCondoCustomItemKey(item.id)] === true)
    .map((item) => ({
      key: getCondoCustomItemKey(item.id),
      label: item.label
    }));
  return [...standard, ...custom];
}

